import { UseState } from '@elearning-platform/ui';
import React, { useMemo, useState } from 'react';

import { VolatileSettingsContext } from '../../contexts';
import { SearchPopupPhase } from '../../enums';
import { VolatileSettingsContextState } from '../../interfaces';
import { VolatileSettingsContextData } from '../../types/internal';

import { VolatileSettingsProviderProps } from './volatileSettingsProvider.types';

export const VolatileSettingsProvider: React.FC<VolatileSettingsProviderProps> = (props: VolatileSettingsProviderProps): JSX.Element => {
  const { children }: VolatileSettingsProviderProps = props;
  const [volatileSettings, setVolatileSettings]: UseState<VolatileSettingsContextState> = useState<VolatileSettingsContextState>({
    isComparisonTablePopupVisible: false,
    searchPopupSettings: { phase: SearchPopupPhase.Closed },
    isAppLoadingVisible: false,
  });

  const value: VolatileSettingsContextData = useMemo(
    (): VolatileSettingsContextData => [volatileSettings, setVolatileSettings],
    [volatileSettings]
  );

  return (
    <VolatileSettingsContext.Provider value={value}>
      {children}
    </VolatileSettingsContext.Provider>
  );
};
